export default function profilePicture() {
  return useState('profilePicture', () => {
    const user = useSanctumUser()

    // @ts-ignore
    if (user.value && user.value.profile_picture) {
      // @ts-ignore
      return `https://static.viral.com.br/${user.value.profile_picture}?v=${user.value.updated_at}`
    }

    return '/assets/images/avatars/3.svg'
  })
}
